{
	"meta": {
		"title": "Nosotros — UpSquad",
		"description": "Toda comunidad merece un hogar de clase mundial. La visión, la misión y la historia de UpSquad."
	},
	"hero": {
		"eyebrow": "Sobre UpSquad",
		"title": "Creemos que toda comunidad merece un",
		"title_accent": "hogar de clase mundial."
	},
	"vision": {
		"eyebrow": "Nuestra visión",
		"title": "Espacios donde las personas crecen.",
		"body": "Construir espacios positivos donde cada persona — sin importar su punto de partida — pueda aprender, crecer, encontrar a su gente y abrirse un futuro que jamás creyó posible."
	},
	"mission": {
		"eyebrow": "Nuestra misión",
		"title": "Herramientas con IA para quienes lideran comunidades.",
		"body": "Dar a las organizaciones de todo el mundo las herramientas con IA y la infraestructura comunitaria necesarias para apoyar de verdad a cada miembro — para que aprender y crecer sea la regla, no la excepción."
	},
	"story": {
		"paragraph_1": "La mayoría de organizaciones que hacen un trabajo significativo — formando emprendedores, apoyando a personas adultas que aprenden, construyendo programas de mentoría — encadenan seis o siete herramientas distintas solo para mantener su comunidad conectada. Pasan más tiempo gestionando software que sirviendo a las personas.",
		"paragraph_2": "Construimos UpSquad porque creemos que las mejores comunidades tienen marca propia, estructura, e IA que de verdad entiende a sus miembros. No una plataforma social genérica. No un LMS pesado. Un espacio que se siente tuyo — y que funciona como un equipo entero detrás de cámaras.",
		"paragraph_3": "Desde Nashville hasta Nueva York y todo Estados Unidos, las comunidades en UpSquad están ayudando a personas adultas a terminar el bachillerato, a estudiantes de medicina a prosperar, a emprendedores a lanzar negocios y a estudiantes universitarios a convertirse en coaches. Eso pasa cuando das a quienes lideran comunidades las herramientas adecuadas."
	},
	"beliefs": {
		"title": "En qué",
		"title_accent": "creemos.",
		"subtitle": "Cuatro principios que orientan cada decisión que tomamos.",
		"items": {
			"1": {
				"title": "La comunidad primero",
				"body": "Cada función que construimos parte de una pregunta: ¿esto ayuda a las personas en la comunidad?"
			},
			"2": {
				"title": "IA con propósito",
				"body": "La IA debe revelar insights y conexiones — no reemplazar las relaciones humanas que dan poder a las comunidades."
			},
			"3": {
				"title": "Simplicidad a escala",
				"body": "Una infraestructura comunitaria de clase mundial no debería requerir un equipo de desarrolladores. Nosotros la construimos para que tú no tengas que hacerlo."
			},
			"4": {
				"title": "Impacto por encima de todo",
				"body": "Medimos el éxito por los resultados que crean nuestros clientes — diplomas obtenidos, empleos conseguidos, conexiones realizadas."
			}
		}
	}
}
